import { ChangeDetectionStrategy, Component, EventEmitter, Inject, inject, Input, Output } from '@angular/core';

import {FormBuilder, FormGroup, FormsModule, Validators, ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReceivableSearchService } from '../receivable-search.service';
import { ReceivableDomain } from '../domain/receivable-domain';

import { MatRadioModule, MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatButtonModule} from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import {
  MAT_DIALOG_DATA,
  MatDialog,  
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
@Component({
  selector: 'app-payment-search-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule,
    MatRadioModule, MatRadioGroup, MatRadioButton, MatInputModule, MatFormFieldModule, MatButtonModule,
    MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatCardModule, MatGridListModule ],
  templateUrl: './edit-amount-due-modal.component.html',
  styleUrl: './edit-amount-due-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: []
})
export class EditAmountDueModalComponent {
  readonly dialogRef = inject(MatDialogRef<EditAmountDueModalComponent>);
  form!: FormGroup;
  @Input() visible: boolean = false;
  receivable!: ReceivableDomain;
  @Output() visibleChange = new EventEmitter<boolean>();

  constructor(
    private fb: FormBuilder, 
    private receivableSearchService: ReceivableSearchService,
    @Inject(MAT_DIALOG_DATA) public data: {receivable: ReceivableDomain}
  ) {
    this.form = this.fb.group({
      newBalanceDue: [null, Validators.required]
    });
    this.receivable = data.receivable;
  }

  saveClick() {
    this.receivableSearchService.removeReceivableFromList(this.receivable);
    this.receivable.balanceDue = this.form.get('newBalanceDue')?.value;
    this.receivableSearchService.addReceivableToList(this.receivable);
    this.closeDialog(this.receivable);
  }

  closeDialog(receivable?: ReceivableDomain) {
    this.dialogRef.close(receivable);
  }

}
